import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phoneContent", "panel"]

  connect() {
    if (!window.gsap || !window.ScrollTrigger) return

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches

    this.tweens = []
    this.triggers = []
    this.currentStep = -1

    this.setupPanelTriggers()
  }

  disconnect() {
    this.tweens.forEach((tween) => {
      if (tween.scrollTrigger) tween.scrollTrigger.kill()
      tween.kill()
    })
    this.triggers.forEach((trigger) => trigger.kill())
    this.tweens = []
    this.triggers = []
  }

  setupPanelTriggers() {
    this.panelTargets.forEach((panel, index) => {
      const trigger = window.ScrollTrigger.create({
        trigger: panel,
        start: "top 60%",
        end: "bottom 40%",
        onEnter: () => this.activateStep(index),
        onEnterBack: () => this.activateStep(index),
      })
      this.triggers.push(trigger)
    })
  }

  activateStep(index) {
    if (index === this.currentStep) return
    this.currentStep = index

    // Kill previous step tweens to prevent unbounded array growth
    this.tweens.forEach((t) => t.kill())
    this.tweens = []

    this.phoneContentTargets.forEach((content, i) => {
      const tween = window.gsap.to(content, {
        opacity: i === index ? 1 : 0,
        duration: this.reducedMotion ? 0 : 0.3,
        ease: "power2.inOut",
      })
      this.tweens.push(tween)
    })
  }
}
